module.exports = __webpack_public_path__ + "static/media/form.3f83beeb.svg";